import { createFileRoute } from '@tanstack/react-router'
import { PortalNotificationsPage } from '@features/communications/components/PortalNotificationsPage'

export const Route = createFileRoute('/_layout/communication/notifications/portal-notifications')({
    component: PortalNotificationsPage,
    staticData: {
        crumb: { label: 'Portal Notifications' },
    },
})
